import { createUseStyles } from '@glu/theming';

// TODO: Add branding styles instead of set bg and colors
export const useStyles = createUseStyles(
  ({
    login: {
      form: { backgroundColor: formBackground }
    },
    palette: { colors, grey },
    spacing: { unit },
    typography: { print }
  }) => ({
    printWrapper: {
      fontFamily: print.fontFamily,
      padding: 20,
      '& .flex': {
        display: 'flex',
        justifyContent: 'space-between'
      }
    },
    printIconContainer: {
      background: 'transparent',
      textAlign: 'right',
      marginRight: 50,
      marginTop: 20,
      '& svg': {
        width: 24,
        height: 24
      },
      '& button': {
        border: 'none',
        background: 'none'
      }
    },
    headerSection: {
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: 14,
      color: colors.thunder
    },
    headerTitle: {
      fontSize: 32,
      fontWeight: 'bold'
    },
    subItemsContainer: {
      display: 'flex',
      '& $subItem:first-child': {
        marginRight: 50
      }
    },
    subItem: {
      fontSize: 14
    },
    headerSummary: {
      textAlign: 'right'
    },
    headerItem: {
      fontSize: 20,
      fontWeight: 'bold'
    },
    headerDivider: {
      background: grey.A100,
      height: 8,
      margin: '16px 0'
    },
    sectionTitle: {
      fontSize: 20,
      color: colors.mineShaft,
      marginBottom: 16,
      fontWeight: 'bold'
    },
    sectionDivider: {
      height: 1,
      background: grey.G600,
      margin: '25px 0 8px 0'
    },
    basicLabel: {
      width: '50%',
      padding: '8px 11px',
      color: colors.rollingStone,
      fontSize: 14
    },
    basicValue: {
      width: '50%',
      color: colors.pickledBluewood,
      padding: '8px 11px',
      fontWeight: 'bold',
      fontSize: 14
    },
    defaultLabel: {
      background: colors.gallery,
      border: `1px solid ${colors.silver}`,
      width: '50%',
      padding: '8px 11px',
      color: colors.pickledBluewood,
      fontWeight: 'bold',
      fontSize: 14
    },
    defaultValue: {
      border: `1px solid ${colors.silver}`,
      width: '50%',
      padding: '8px 11px',
      fontSize: 14
    },
    printTablesContainer: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    printTableContainer: {
      width: '45%'
    },
    printTable: {
      width: '100%'
    },
    printTableHeader: {
      fontSize: 18,
      color: colors.mineShaft,
      display: 'flex',
      fontWeight: 'bold',
      marginBottom: 15
    },
    printSection: {
      pageBreakInside: 'avoid'
    },
    logo: {
      maxWidth: '400px !important',
      maxHeight: '75px !important'
    },
    logoWrapper: {
      display: 'none',
      backgroundColor: formBackground,
      boxShadow: `inset 0 0 0 400px ${formBackground}`,
      padding: 2 * unit,
      marginBottom: 1 * unit,
      width: 'min-content',
      '@media only print': {
        display: 'block'
      }
    }
  })
);

export default useStyles;
